module.exports = __webpack_public_path__ + "assets/img/D3.45ecd600.png";